import styled from "styled-components";

const HashtagBoldStyle = styled.span`
    font-weight:700;
    cursor: pointer;
`

export {HashtagBoldStyle}